import { render, staticRenderFns } from "./folders-my-files.vue?vue&type=template&id=6b809b02&scoped=true"
import script from "./folders-my-files.vue?vue&type=script&lang=js"
export * from "./folders-my-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b809b02",
  null
  
)

export default component.exports